export default "__VITE_ASSET___bxd5KxU__"